var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55964 0C4.37884 0 4.22063 0.0847517 4.03418 0.231655L0.220354 3.31662C0.0847517 3.42962 0 3.59912 0 3.80818C0 4.19238 0.310756 4.47489 0.666713 4.47489C0.830566 4.47489 0.99442 4.41274 1.15827 4.28278L4.56529 1.53683L7.96666 4.28278C8.12486 4.41274 8.29436 4.47489 8.45822 4.47489C8.81417 4.47489 9.12493 4.19238 9.12493 3.80818C9.12493 3.59912 9.04018 3.42962 8.90458 3.31662L5.0851 0.231655C4.9043 0.0847517 4.74609 0 4.55964 0ZM4.55964 10.4697C4.74609 10.4697 4.9043 10.3906 5.0851 10.2437L8.90458 7.15869C9.04018 7.04004 9.12493 6.87054 9.12493 6.66713C9.12493 6.27727 8.81417 5.99477 8.45822 5.99477C8.29436 5.99477 8.12486 6.06257 7.96666 6.19252L4.56529 8.93848L1.15827 6.19252C0.99442 6.06257 0.830566 5.99477 0.666713 5.99477C0.310756 5.99477 0 6.27727 0 6.66713C0 6.87054 0.0847517 7.04004 0.220354 7.15869L4.03418 10.238C4.22063 10.3906 4.37884 10.4697 4.55964 10.4697Z",
    fill: "#021C5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron_up_down.53b03200b8c4f3f1f608e58780b31d6d.svg";
export { ForwardRef as ReactComponent };